'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (
		Array.prototype.includes
		&& Array(1).includes(undefined) // https://bugzilla.mozilla.org/show_bug.cgi?id=1767541
	) {
		return Array.prototype.includes;
	}
	return implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/array-includes/polyfill.js
// module id = 326
// module chunks = 0